import '@css/base.less';
import '@css/grid.less';
import '@css/unit.less';
import '@css/module.less';
import './app.less';
import '@css/app-v2.less';
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import 'react-dates/initialize';
import CreatorcenterService from '@music/creatorcenter-service';
import QiYuContent from './component/qiyucontent';
import appHistory from './util/history';
import checkAndredirect, { redirectToNewProject } from './util/redirect';
import createStore from './store/store';
import { userRequest, cashEncourageStateRequest, userAuthInfo } from './util/userinfo';
import getRoutes from './router';
import hash from './util/repushhash';

redirectToNewProject();

Promise.all([userRequest(), cashEncourageStateRequest(), userAuthInfo()]).then((res) => {
    const userResult = res[0];
    const cashResult = res[1];
    const authResult = res[2];
    const resData = userResult.data;
    const User = {
        request: false,
        msg: '',
        logout_request: false,
        formEle: null,
        count: 0,
        profile: {
            userId: resData.uid,
            nickName: resData.nickName,
            avatarUrl: resData.avatarUrl
        },
        data: { ...resData },
        cashEncourageState: cashResult.data,
        authInfo: authResult.data
    };

    checkAndredirect(User.cashEncourageState); // 检查是否需要重定向
    const store = createStore({ User });
    const routes = getRoutes(User);
    const path = hash();
    ReactDOM.render(
        <Provider store={store}>
            <Router history={appHistory} routes={routes} />
        </Provider>,
        document.getElementById('j-app-v2'),
        () => appHistory.replace(path)
    );
    // 添加客服入口
    const oDiv = document.createElement('div');
    document.body.appendChild(oDiv);
    ReactDOM.render(
        <CreatorcenterService>
            <QiYuContent />
        </CreatorcenterService>, oDiv
    );
});



// WEBPACK FOOTER //
// ./client/app.js